import { render, staticRenderFns } from "./ManagementAddContractorInfoLanguages.vue?vue&type=template&id=25068e4a&scoped=true"
import script from "./ManagementAddContractorInfoLanguages.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoLanguages.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAddContractorInfoLanguages.vue?vue&type=style&index=0&id=25068e4a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25068e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25068e4a')) {
      api.createRecord('25068e4a', component.options)
    } else {
      api.reload('25068e4a', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoLanguages.vue?vue&type=template&id=25068e4a&scoped=true", function () {
      api.rerender('25068e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoLanguages.vue"
export default component.exports